const Opciones = {
    APROBAR_ORDEN_PAGO: {
        opc_id: "aprobar_orden_pago",
        opc_nombre: "Aprobar Orden Pago	2"
    },
    APROBAR_ORDEN_COMPRA: {
        opc_id: "aprobar_orden_compra",
        opc_nombre: "Aprobar Orden Compra	1"
    },
    APROBAR_ORDEN_VENTA: {
        opc_id: "aprobar_orden_venta",
        opc_nombre: "Aprobar Orden Venta	17"
    },
    REGISTRAR_PRODUCTO: {
        opc_id: "registrar_producto",
        opc_nombre: "Registrar producto	5"
    },
}
export default Opciones